require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-102-intro-to-software-development.json") })
        }
      }, "path---courses-code-102-intro-to-software-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-102-intro-to-software-development!./.cache/json/courses-code-102-intro-to-software-development.json
// module id = 1165
// module chunks = 231608221292675